import { ControlsContent } from "../../../ui/controls/content.js";
import { ControlsGroup } from "../../../ui/controls/group.js";
import { ControlsRoot } from "../../../ui/controls/root.js";
import { Value } from "../../../ui/time/value.js";
import { TooltipProvider } from "../../../ui/tooltip/provider.js";
import { ButtonTooltip } from "../shared/components/buttons/button-tooltip.js";
import { AudioTimeSlider } from "../shared/skins/shared/audio/time-slider.js";
import { SeekButton } from "./components/buttons/seek-button.js";
import { VolumePopover } from "./components/controls/volume-popover.js";
import { AudioPlayButton } from "./skins/shared/audio/play-button.js";
import { AudioSettingsMenu } from "./skins/shared/audio/settings-menu.js";
import { jsx, jsxs } from "react/jsx-runtime";
import { cn } from "@videojs/utils/style";
//#region src/internal/skins/default-audio/controls.tsx
/** @jsxImportSource react */
function DefaultAudioControls() {
	return /* @__PURE__ */ jsx(ControlsRoot, {
		visibility: "always",
		children: /* @__PURE__ */ jsx(ControlsContent, {
			className: cn("audio-controls", "audio-controls-content"),
			children: /* @__PURE__ */ jsxs(TooltipProvider, { children: [
				/* @__PURE__ */ jsxs(ControlsGroup, {
					className: "audio-controls-start",
					children: [
						/* @__PURE__ */ jsx(AudioPlayButton, {}),
						/* @__PURE__ */ jsx(ButtonTooltip, {
							boundary: "viewport",
							side: "top",
							children: /* @__PURE__ */ jsx(SeekButton, {
								className: "audio-seek-button",
								seconds: -10
							})
						}),
						/* @__PURE__ */ jsx(ButtonTooltip, {
							boundary: "viewport",
							side: "top",
							children: /* @__PURE__ */ jsx(SeekButton, {
								className: "audio-seek-button",
								seconds: 10
							})
						})
					]
				}),
				/* @__PURE__ */ jsxs(ControlsGroup, {
					className: "audio-time-slider-group",
					children: [
						/* @__PURE__ */ jsx(Value, {
							className: "media-time-value",
							type: "current"
						}),
						/* @__PURE__ */ jsx(AudioTimeSlider, { previewOverflow: "visible" }),
						/* @__PURE__ */ jsx(Value, {
							className: cn("media-time-toggle", "audio-time-remaining-value"),
							type: "remaining",
							toggle: true
						})
					]
				}),
				/* @__PURE__ */ jsxs(ControlsGroup, {
					className: "audio-controls-end",
					children: [/* @__PURE__ */ jsx(AudioSettingsMenu, {}), /* @__PURE__ */ jsx(VolumePopover, { boundary: "viewport" })]
				})
			] })
		})
	});
}
//#endregion
export { DefaultAudioControls };

//# sourceMappingURL=controls.js.map